// -----------------------------------------------------------------------------
// SOCIAL / FEATURED CONFIG
// -----------------------------------------------------------------------------
// Swap the entries below whenever you post new work on Instagram or add new
// Etsy listings. Everything the site shows in the "Fresh Off The Press" and
// "Also On Etsy" strips is driven from this one file — no rebuild needed
// beyond a normal deploy.
//
// PROFILE / SHOP LINKS (also referenced in Footer.jsx):
//   DTF Instagram : https://www.instagram.com/downtofilmapparel_/
//   TSC Instagram : https://www.instagram.com/the_sticky_chick/
//   Etsy Shop     : https://www.etsy.com/shop/DownToFilmApparel
// -----------------------------------------------------------------------------

/**
 * Instagram posts shown under the Shop page. Three per brand.
 *   image   : URL to the post's still image. Can be:
 *             - a local file in /public/media/  (e.g. "/media/hero.webp")
 *             - or a full https URL to the Instagram-hosted image
 *   caption : one-liner shown on hover / caption row
 *   url     : the actual post URL (or profile URL as a fallback)
 */
export const INSTAGRAM_POSTS = {
  dtf: [
    {
      image: "/media/hero.webp",
      caption: "American flag DTF transfer — heat pressed on charcoal tee",
      url: "https://www.instagram.com/downtofilmapparel_/",
    },
    {
      image: "/media/classic-tee.webp",
      caption: "Small-batch tee run — quick turnaround for a local crew",
      url: "https://www.instagram.com/downtofilmapparel_/",
    },
    {
      image: "/media/gang-sheet.webp",
      caption: "14×18 DTF gang sheet packed with a client's designs",
      url: "https://www.instagram.com/downtofilmapparel_/",
    },
  ],
  sc: [
    {
      image: "/media/hero-2.webp",
      caption: "Precision Speed Shop nitrous bottle wrap — custom vinyl job",
      url: "https://www.instagram.com/the_sticky_chick/",
    },
    {
      image: "/media/credit-card-sticker.webp",
      caption: "Credit-card-sized custom vinyl for a landscaping client",
      url: "https://www.instagram.com/the_sticky_chick/",
    },
    {
      image: "/media/door-sign.webp",
      caption: "UV-resistant door signs for a coffee shop opening",
      url: "https://www.instagram.com/the_sticky_chick/",
    },
  ],
};

/**
 * Etsy featured row shown on the home page above the final CTA.
 * Provide 3-4 entries. All open the actual Etsy listing in a new tab.
 */
export const ETSY_FEATURED = [
  {
    image: "/media/classic-tee.webp",
    title: "Custom DTF Tee",
    price: "from $10",
    url: "https://www.etsy.com/shop/DownToFilmApparel",
    brand: "dtf",
  },
  {
    image: "/media/credit-card-sticker.webp",
    title: "Credit / Debit Card Stickers",
    price: "from $2",
    url: "https://www.etsy.com/shop/DownToFilmApparel",
    brand: "sc",
  },
  {
    image: "/media/gang-sheet.webp",
    title: "14×18 DTF Gang Sheet",
    price: "$18",
    url: "https://www.etsy.com/shop/DownToFilmApparel",
    brand: "dtf",
  },
  {
    image: "/media/hero-2.webp",
    title: "Vinyl Decals (Weatherproof)",
    price: "from $3",
    url: "https://www.etsy.com/shop/DownToFilmApparel",
    brand: "sc",
  },
];

/**
 * Popl digital business card URLs — rendered as small QR codes on the About page.
 */
export const POPL_CARDS = {
  dtf: "https://popl.co/profile/downtofilmapparel",
  sc: "https://popl.co/profile/thestickychick",
};
